
<div class="row">
  <div class="col-lg-2"></div>
  <div class="col-lg-8 paddingZero">
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-4 col-md-4 col-sm-4  paddingZero">
        <label class="lbl" [for]="jobNameLBL">{{quoteHeaderTxt.jobNameLbl?quoteHeaderTxt.jobNameLbl:quoteHeaders.jobNameLbl}} </label>
        <input type="text" kendoTextBox id="jobNameId" [(ngModel)]="quoteHeader.jobName" [disabled]="this.quoteService.selectedQuoteHeader.isLocked" (blur)="fieldChangeEvent()" #jobNameLBL
               class="kendoInput" />
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
        <label class="lbl" [for]="marketSegmentLBL">{{quoteHeaderTxt.marketSegmentLbl?quoteHeaderTxt.marketSegmentLbl:quoteHeaders.marketSegmentLbl}}</label>
        <kendo-dropdownlist class="kendoInput" #marketSegmentLBL
                            [(ngModel)]="quoteHeader.marketSegmentObj"
                            [data]="marketSegments"
                            (valueChange)="marketSegmentChange($event)"
                            textField="name"
                            [ngStyle]="this.quoteService.selectedQuoteHeader.isLocked==true ? {'pointer-events': 'none','opacity': '0.6'} : {}"
 
                            valueField="name">
        </kendo-dropdownlist>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4  leedTop paddingZero">
        <kendo-switch [(ngModel)]="quoteHeader.leed" [onLabel]="'Yes'" #leedLBL [offLabel]="'No'" [disabled]="this.quoteService.selectedQuoteHeader.isLocked"
                      class="leedSwitchCls" (click)="fieldChangeEvent()">
        </kendo-switch>
        <label class="lbl" [for]="leedLBL">{{quoteHeaderTxt.leedLbl?quoteHeaderTxt.leedLbl:quoteHeaders.leedLbl}}</label>
      </div>
    </div>
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
        <label class="lbl" [for]="jobNumberLbl">{{quoteHeaderTxt.jobNumberLbl?quoteHeaderTxt.jobNumberLbl:quoteHeaders.jobNumberLbl}} </label>
        <input type="text" kendoTextBox [(ngModel)]="quoteHeader.jobNumberRevision" readonly #jobNumberLbl [disabled]="this.quoteService.selectedQuoteHeader.isLocked"
               class="kendoInput" />
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
        <label class="lbl" [for]="quoteDateLbl">{{quoteHeaderTxt.quoteDateLbl?quoteHeaderTxt.quoteDateLbl:quoteHeaders.quoteDateLbl }} </label>
        <input type="text" kendoTextBox [(ngModel)]="quoteHeader.quoteDateForDisplay" readonly #quoteDateLbl
               class="kendoInput" />
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
        <label class="lbl" [for]="expirationDateLbl">{{quoteHeaderTxt.expirationDateLbl?quoteHeaderTxt.expirationDateLbl:quoteHeaders.expirationDateLbl }} </label>
        <input type="text" kendoTextBox [(ngModel)]="quoteHeader.expirationDateForDisplay" readonly #expirationDateLbl
               class="kendoInput" />
      </div>
    </div>


    <div class="row col-lg-12" *ngIf="showUpdate">
      <div class="col-lg-6">
        <button class="cancel-button" kendoButton (click)="cancel()" [disabled]="quoteHeader.updateInProgress">
          {{quoteHeaderTxt.cancelLbl?quoteHeaderTxt.cancelLbl:quoteHeaders.cancelLbl}}

        </button>
        <button kendoButton class="m-3 clearKendoButton btn btn-success" [disabled]="quoteHeader.updateInProgress"
                (click)="updateQuoteHeader()">
          {{quoteHeaderTxt.updateLbl?quoteHeaderTxt.updateLbl:quoteHeaders.updateLbl}}
          <kendo-loader *ngIf="quoteHeader.updateInProgress" style="color:blue"></kendo-loader>
        </button>

      </div>

    </div>
  </div>

</div>
<br />
<p class="ml-5 mt-2" style="color: red" *ngIf="this.quoteService.KD_Quote_Has_Error">
  <b>
    Please review all quote items, ensuring all quote pages are reviewed, for item(s) in error and take corrective action to resolve error(s).
  </b>
</p>
<!--<p *ngIf= "doesHaverror">ERROR
</p>-->
<br />
<app-quick-add-quote></app-quick-add-quote>
<br />
